<template>
  <div class="purchase-coordination">
    <banner clazz="purchase-coordination-banner" url="purchaseCoordination">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <el-button class="banner-button" round @click="goMore('caigouxietong-banner-tiyan')">申请体验</el-button>
      </template>
    </banner>
    <div class="purchase-coordination-section1">
      <div class="section1-region">
        <h1 class="section1-title">统一智能化采购协同平台</h1>
        <div class="section1-divider"></div>
        <div class="section1-content">
          <!-- <div class="content-title">甄云采购协同</div> -->
          <p class="content-describe">供需双方需求在线可视化，实现按需生产，按需发货，自动对账补货提醒等全流程智能管理，缩短采购周期，满足采购急需，降低库存积压</p>
          <ul class="content-detail clearfix">
            <li class="content-img fl" v-for="(item, index) in section1Data" :key="index">
              <img class="detail-img" v-lazy="item.src" alt="统一智能化采购协同平台">
              <p class="detail-content"> {{item.title}} </p>
            </li>
          </ul>
        </div>
        <hover-button text="了解更多" clazz="consult-button dib" :duration=0.5
                      @click.native="goMore('caigouxietong-pingtai-liaojiegengduo')"/>
      </div>
    </div>
    <div class="purchase-coordination-section2">
      <div class="section2-content">
        <h1 class="section2-title">预测需求，动态掌握供应商备库情况，合理安排排产计划</h1>
        <div class="section2-divider"></div>
        <div class="section2-main">
          <p class="section2-detail">采购企业根据公司生产需求，预测所需物料，制定备货及送货计划，通过SRM系统下发至各供应商，</p>
          <p class="section2-detail">经由供应商反馈物料交期，智能分析报表数据，合理安排排产计划，全程在线实现，避免时间空档，提升生产效率</p>
        </div>
      </div>
    </div>
    <div class="purchase-coordination-section3">
      <div class="section3-region">
        <h1 class="section3-title">采购订单协同，智能提醒，一键触达</h1>
        <div class="section3-divider"></div>
        <div class="section3-content">
          <p class="content-describe">颠覆传统线下电话/qq/传真等重复低效沟通方式，自动生成订单，消息全方位实时触达供应商，</p>
          <p class="content-describe">智能提醒订单的变更，退货</p>
          <ul class="content-detail clearfix">
            <li class="content-left fl">
              <img class="section3-img-left fr" src="../../assets/img/purchaseCoordination/peitu1-2.png" alt="采购订单协同">
            </li>
            <li class="content-right fl">
              <div class="content">
                <div class="right-detail">
                  <span class="detail-bar"></span>订单自动创建及发布：与ERP对接，实时同步
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>消息预警：短信&邮件&系统消息全方位及时通知供应商
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>在线确认：订单在线发布与确认，简洁高效
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>版本控制：采购订单版本变更，通知供应商
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="purchase-coordination-section3 purchase-coordination-section3-2 ">
      <div class="section3-region">
        <h1 class="section3-title">规范送货流程、缩短供货周期、降低库存积压</h1>
        <div class="section3-divider"></div>
        <div class="section3-content">
          <p class="content-describe">送货过程规范化，紧急物资可追踪，集成条码系统实现扫码入库，合理优化库存管理，实现高效管理送货全流程</p>
          <ul class="content-detail clearfix section3-under">
            <li class="content-right fl">
              <div class="under-conter-left fr">
                <div class="content">
                  <div class="right-detail">
                    <span class="detail-bar"></span>基于订单内容创建送货单，格式统一，快捷方便
                  </div>
                  <div class="right-detail">
                    <span class="detail-bar"></span>查看收货看板，采购方可提前获知供应商送货计划，便于接收准备
                  </div>
                  <div class="right-detail">
                    <span class="detail-bar"></span>紧急物资：对接物流API，小时级物流进度追踪
                  </div>
                  <div class="right-detail">
                    <span class="detail-bar"></span>基于送货单接收，与条码系统集成，实现扫码接收入库；装箱单、<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;送货单打印，便于接收盘点
                  </div>
                  <div class="right-detail">
                    <span class="detail-bar"></span> 基于交货日期可以控制供应商交货时间，以优化库存管理
                  </div>
                  <div class="right-detail">
                    <span class="detail-bar"></span>接收入库数据回传SRM，便于供应商确认收货情况
                  </div>
                </div>
              </div>
            </li>
            <li class="content-left under-conter-right fl">
              <img class="section3-img-left fl" src="../../assets/img/purchaseCoordination/peitu2-2.png" alt="规范送货流程">
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="purchase-coordination-section3 purchase-coordination-section3-3">
      <div class="section3-region">
        <h1 class="section3-title">账单自动生成，对账准确高效，透明可查</h1>
        <div class="section3-divider"></div>
        <div class="section3-content">
          <ul class="content-detail clearfix">
            <li class="content-left fl">
              <img class="section3-img-left fr" src="../../assets/img/purchaseCoordination/peitu3-2.png"
                   alt="账单自动生成，对账准确高效，透明可查">
            </li>
            <li class="content-right fl">
              <div class="content">
                <div class="right-detail">
                  <span class="detail-bar"></span>基于ERP入库数据账单自动生成，准确高效，发票审批
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>一键导入ERP，对账准确，减轻财务人员繁琐的发票录入工作，<br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;订单、送货单、入库单、发票数据高度统一
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>无需结算单，采购价格透明可查，付款回传，方便供应商查看<br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;ERP的发票情况及付款情况
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="purchase-coordination-section3 purchase-coordination-section3-4 ">
      <div class="section3-region">
        <h1 class="section3-title">质量问题闭环管理，追踪每一次质量事件</h1>
        <div class="section3-divider"></div>
        <div class="section3-content">
          <ul class="content-detail clearfix section3-under">
            <li class="content-right fl">
              <div class="under-conter-left fr">
                <div class="content">
                  <div class="right-detail">
                    <span class="detail4-bar"></span>8D：根据质检结果可直接创建8D（或手工创建），由供应商及时<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;反馈问题原因并提交临时&永久解决措施
                  </div>
                  <div class="right-detail">
                    <span class="detail4-bar"></span>索赔：根据质检结果/8D可发布索赔单，将每一笔索赔追溯到原始<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;订单，全流程清晰可查询
                  </div>
                </div>
              </div>
            </li>
            <li class="content-left under-conter-right fl">
              <img class="section3-img-left fl" src="../../assets/img/purchaseCoordination/peitu4-2.png"
                   alt="质量问题闭环管理，追踪每一次质量事件">
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="purchase-coordination-section3 purchase-coordination-section3-5">
      <div class="section3-region">
        <h1 class="section3-title">寄售库存协同，供应商补货更及时</h1>
        <div class="section3-divider"></div>
        <div class="section3-content">
          <ul class="content-detail clearfix">
            <li class="content-left fl">
              <img class="section3-img-left fr" src="../../assets/img/purchaseCoordination/peitu5-2.png"
                   alt="寄售库存协同，供应商补货更及时">
            </li>
            <li class="content-right fl">
              <div class="content">
                <div class="right-detail">
                  <span class="detail-bar"></span>采供双方实时掌握备库情况和消耗记录、基于安全库存控制供<br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;应商发运
                </div>
                <div class="right-detail">
                  <span class="detail-bar"></span>获取库存的预警标志至SRM，自动触发补货相关提醒
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'PurchaseCoordination',
  metaInfo () {
    return {
      title: this.$seo.purchasecoordination.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.purchasecoordination.keywords
      },
      {
        name: 'description',
        content: this.$seo.purchasecoordination.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      section1Data: [
        {
          title: '供应商协同',
          src: require('../../assets/img/purchaseCoordination/1@2x.png')
        },
        {
          title: '采购订单协同',
          src: require('../../assets/img/purchaseCoordination/2@2x.png')
        },
        {
          title: '物流协同',
          src: require('../../assets/img/purchaseCoordination/3@2x.png')
        },
        {
          title: '财务结算',
          src: require('../../assets/img/purchaseCoordination/4@2x.png')
        },
        {
          title: '质量协同',
          src: require('../../assets/img/purchaseCoordination/5@2x.png')
        },
        {
          title: '寄售库存协同',
          src: require('../../assets/img/purchaseCoordination/6@2x.png')
        }
      ]
    }
  },
  methods: {
    // 了解更多
    goMore (code) {
      this.openRegister(false, code)
    }
  },
  mounted () {
    if (this.$route.query.top) {
      window.scrollTo(0, this.$route.query.top)
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/purchaseCoordination.scss";
</style>



// WEBPACK FOOTER //
// purchaseCoordination.vue?40781b88